export default "__VITE_ASSET__Dapu21ta__"